<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12.908 2.08a1 1 0 00-1.816 0L8.32 8.088l-6.46.922a1 1 0 00-.492 1.764l4.99 4.084-1.818 6.367a1 1 0 001.485 1.127L12 18.674l5.976 3.678a1 1 0 001.486-1.127l-1.82-6.367 4.991-4.084a1 1 0 00-.491-1.764l-6.462-.923-2.772-6.006zM12 4.887v11.44l.524.322 4.307 2.65-1.292-4.523-.181-.633.509-.416 3.738-3.058-4.746-.678-.539-.077-.228-.494L12 4.886z"/></svg>